import { combineReducers } from 'redux';

import { CHANGE_LOCATION_ACTION as CHANGE_LOCATION } from '../../../shared/config/locations';
import compartments from './Compartment/Compartment.reducers';
import {
  FETCH_BOXES,
  FETCH_BOXES_SUCCESS,
  FETCH_BOXES_ERROR,
  FETCH_BOX_BY_ID,
  FETCH_BOX_BY_ID_SUCCESS,
  FETCH_BOX_BY_ID_ERROR,
  SAVE_BOX_BY_ID,
  SAVE_BOX_BY_ID_SUCCESS,
  SAVE_BOX_BY_ID_ERROR,
  RESET_BOXES,
  REMOVE_BOX_BY_ID_SUCCESS,
  SAVE_COMPARTMENT_SUCCESS,
  REMOVE_COMPARTMENT_SUCCESS
} from './Box.actions';

// Meta

const loading = (state = false, action) => {
  switch (action.type) {
    case FETCH_BOXES:
      return true;

    case FETCH_BOXES_SUCCESS:
    case FETCH_BOXES_ERROR:
      return false;

    default:
      return state;
  }
};

const list = (state = {}, action) => {
  switch (action.type) {
    case FETCH_BOXES_SUCCESS:
      return action.payload.meta;

    case FETCH_BOXES_ERROR:
      return false;

    case SAVE_BOX_BY_ID_SUCCESS:
      return {
        ...state,
        total: !action.id ? state.total + 1 : state.total
      };

    case REMOVE_BOX_BY_ID_SUCCESS:
      return {
        ...state,
        total: state.total - 1
      };

    default:
      return state;
  }
};

const meta = combineReducers({
  loading,
  list
});

export const box = (state = {}, action) => {
  switch (action.type) {
    case FETCH_BOXES_SUCCESS:
      return {
        id: state.id,
        type: state.type,
        ...state.attributes,
        compartments: state.relationships?.compartments?.data?.map(c => ({
          id: c.id,
          type: c.type,
          ...c.attributes
        })) || [],
        location: state.relationships?.location?.data ? {
          id: state.relationships.location.data.id,
          type: state.relationships.location.data.type,
          ...state.relationships.location.data.attributes
        } : {}
      };

    case SAVE_BOX_BY_ID_SUCCESS:
    case FETCH_BOX_BY_ID_SUCCESS:
      return {
        ...action.payload.data.attributes,
        id: action.payload.data.id || state.id,
        type: action.payload.data.type || state.type,
        loading: false,
        compartments: action.payload.data.relationships?.compartments?.data?.map(c => ({
          id: c.id,
          type: c.type,
          ...c.attributes
        })) || [],
        location: action.payload.data.relationships?.location?.data ? {
          id: action.payload.data.relationships.location.data.id,
          type: action.payload.data.relationships.location.data.type,
          ...action.payload.data.relationships.location.data.attributes
        } : {}
      };

    default:
      return state;
  }
};

// ITEMS
const items = (state = [], action) => {
  switch (action.type) {
    case FETCH_BOXES_SUCCESS:
      return action.payload.data.map(b => box(b, action));

    case SAVE_BOX_BY_ID_SUCCESS: {
      const current = state.find(b => String(b.id) === String(action.payload.data.id));

      if (current) {
        return state.map(b => {
          if (String(action.payload.data.id) === String(b.id)) {
            return box(b, action);
          }
          return b;
        });
      } else {
        return [...state, box({}, action)];
      }
    }

    case REMOVE_BOX_BY_ID_SUCCESS:
      return state.filter(item => item.id !== parseInt(action.id, 10));

    case SAVE_COMPARTMENT_SUCCESS: {
      return state.map(b => {
        if (String(b.id) === String(action.payload.data.attributes.box)) {
          let current = b.compartments.find(c => String(c.id) === String(action.payload.data.id));

          if (current) {
            return {
              ...b,
              compartments: b.compartments.map(c => {
                if (String(action.payload.data.id) === String(c.id)) {
                  return {
                    id: action.payload.data.id,
                    type: action.payload.data.type,
                    ...action.payload.data.attributes
                  };
                }
                return c;
              })
            };
          } else {
            return {
              ...b,
              compartments: [
                ...b.compartments,
                {
                  ...action.payload.data.attributes,
                  id: action.payload.data.id,
                  type: action.payload.data.type
                }
              ]
            };
          }
        }
        return b;
      });
    }

    case REMOVE_COMPARTMENT_SUCCESS:
      return state.map(b => {
        if (String(b.id) === String(action.boxId)) {
          return {
            ...b,
            compartments: b.compartments.filter(c => String(c.id) !== String(action.id))
          };
        }
        return b;
      });

    case FETCH_BOXES_ERROR:
    case RESET_BOXES:
      return [];

    default:
      return state;
  }
};

// SELECTED

const selected = (state = {}, action) => {
  switch (action.type) {
    case FETCH_BOX_BY_ID:
      return {
        id: action.id,
        loading: true
      };

    case SAVE_BOX_BY_ID:
      return {
        ...state,
        loading: true
      };

    case FETCH_BOX_BY_ID_SUCCESS:
    case SAVE_BOX_BY_ID_SUCCESS:
      return box(state, action);

    case SAVE_COMPARTMENT_SUCCESS: {
      const current = state.compartments?.find(c => String(c.id) === String(action.payload.data.id));

      if (current) {
        return {
          ...state,
          compartments: state.compartments.map(c => {
            if (String(action.payload.data.id) === String(c.id)) {
              return {
                ...action.payload.data.attributes,
                id: action.payload.data.id,
                type: action.payload.data.type
              };
            }
            return c;
          })
        };
      } else {
        return {
          ...state,
          compartments: [
            ...(state.compartments || []),
            {
              ...action.payload.data.attributes,
              id: action.payload.data.id,
              type: action.payload.data.type
            }
          ]
        };
      }
    }

    case REMOVE_COMPARTMENT_SUCCESS:
      return {
        ...state,
        compartments: state.compartments?.filter(c => String(c.id) !== String(action.id)) || []
      };

    case SAVE_BOX_BY_ID_ERROR:
      return {
        ...state,
        loading: false
      };

    case REMOVE_BOX_BY_ID_SUCCESS:
    case RESET_BOXES:
    case CHANGE_LOCATION:
    case FETCH_BOXES_ERROR:
    case FETCH_BOX_BY_ID_ERROR:
      return {
        loading: false
      };

    default:
      return state;
  }
};

// MAIN
const reducer = combineReducers({
  meta,
  items,
  selected,
  compartments
});

reducer.reducer = 'boxes';

export default reducer;
